export default __webpack_public_path__ + "static/media/about_have.e712c68e.png";